export const canAddResource = state => state.modal.active === state.modal.resources.length - 1;

// Modal is safe to close only when there is 1 resource remaining
export const canCloseModal = state => state.modal.resources.length === 1;

export const getActiveResource = state => state.modal.resources[state.modal.active];

// Can only close the last resource in chain safely
export const canCloseResource = state => state.modal.active === state.modal.resources.length - 1;
